import { Divider } from '@doist/marketist';
import { useTranslation } from 'next-i18next';
import { ProductUIAppWindow } from '../product-ui-app-window/product-ui-app-window';
import { ProductUICursorContainer } from '../product-ui-cursor/product-ui-cursor';
import { ProductUIBasicListItem, ProductUISidebarHeaderItem } from '../product-ui-list-item';
import { ProductUISceneContainer, ProductUISceneLayer } from '../product-ui-scene-container/product-ui-scene-container';
import { ProductUISidebar, ProfileMenu, SideBarFavorites, SideBarSection } from '../product-ui-sidebar/product-ui-sidebar';
import { TemplateSidebarMainFilters } from '../product-ui-sidebar/product-ui-sidebar-templates';
import { ProductUISkeletonText } from '../product-ui-skeleton-text/product-ui-skeleton-text';
import { ProductUITask } from '../product-ui-task/product-ui-task';
import { ProductUITaskCircle } from '../product-ui-task-circle/product-ui-task-circle';
import { ProductUIView } from '../product-ui-view/product-ui-view';
function ProjectsScene() {
  const {
    t
  } = useTranslation('productui');
  return <ProductUISceneContainer backgroundVariant="wave-one" data-sentry-element="ProductUISceneContainer" data-sentry-component="ProjectsScene" data-sentry-source-file="projects.tsx">
            <ProductUISceneLayer position="bottomRight" data-sentry-element="ProductUISceneLayer" data-sentry-source-file="projects.tsx">
                <ProductUIAppWindow inlineSize={808} blockSize="calc(100% + 7px)" showSidebar sidebar={<ProductUISidebar profileMenu={<ProfileMenu dailyProgress={0.7} />} views={<TemplateSidebarMainFilters />} favorites={<SideBarFavorites>
                                    <SideBarSection>
                                        <div>
                                            <ProductUICursorContainer size="lg">
                                                <ProductUIBasicListItem icon="project" iconColor="red" label={t('sequence.projects.fitness')} hovered active />
                                            </ProductUICursorContainer>
                                            <ProductUIBasicListItem icon="project" iconColor="limeGreen" label={t('sequence.projects.roadmap')} />
                                            <ProductUIBasicListItem icon="project" iconColor="blue" label={t('sequence.projects.appointments')} />
                                        </div>
                                    </SideBarSection>
                                </SideBarFavorites>} workspaces={<>
                                    <SideBarSection>
                                        <ProductUISidebarHeaderItem icon="personal" abstracted={true} skeletonWidth="60" />
                                    </SideBarSection>
                                    <SideBarSection>
                                        <ProductUISidebarHeaderItem icon="team" abstracted={true} skeletonWidth="40" />
                                    </SideBarSection>
                                </>} />} view={<ProductUIView variant="list">
                            <ProductUIView.Header title={t('sequence.projects.fitness')} breadcrumbs={[t('sequence.projects.myProjects'), '']} />
                            <ProductUIView.Section>
                                <Divider />
                                <ProductUITask taskCircleSection={<ProductUITaskCircle priority="p4" />}>
                                    {t('sequence.projects.yoga')}
                                </ProductUITask>
                                <Divider />
                                <ProductUITask taskCircleSection={<ProductUITaskCircle priority="p4" />}>
                                    {t('sequence.projects.gym')}
                                </ProductUITask>
                                <Divider />
                                <ProductUITask taskCircleSection={<ProductUITaskCircle priority="p4" />}>
                                    <ProductUISkeletonText width="40" />
                                </ProductUITask>
                                <Divider />
                                <ProductUITask taskCircleSection={<ProductUITaskCircle priority="p4" />}>
                                    <ProductUISkeletonText width="20" />
                                </ProductUITask>
                                <Divider />
                                <ProductUITask taskCircleSection={<ProductUITaskCircle priority="p4" />}>
                                    <ProductUISkeletonText width="100" />
                                </ProductUITask>
                                <Divider />
                                <ProductUITask taskCircleSection={<ProductUITaskCircle priority="p4" />}>
                                    <ProductUISkeletonText width="40" />
                                </ProductUITask>
                                <Divider />
                            </ProductUIView.Section>
                        </ProductUIView>} data-sentry-element="ProductUIAppWindow" data-sentry-source-file="projects.tsx" />
            </ProductUISceneLayer>
        </ProductUISceneContainer>;
}
export { ProjectsScene };